import { ApiResponse } from "../../types";
import { dashboardClient } from "../config/apiClient";

export interface SummaryData {
  totalCount: number;
  totalDuration: number;
  video: number;
  audio: number;
}

export const getSummary = async (): Promise<ApiResponse<SummaryData>> => {
  const response = await dashboardClient.get<ApiResponse<SummaryData>>(
    `/summary`
  );
  return response.data;
};
